<template>
    <b-modal
        :title="$t('Invite Guide')"
        hide-footer
        v-model="modal"
        centered
        no-close-on-esc
        
    >
        <creator-invite-guides />
    </b-modal>
</template>

<script>
import CreatorInviteGuides from "@/components/creator/guide/view/CreatorInviteGuides";

export default {
    computed: {
        modal: {
            get() {
                return this.$store.state.interface.influencerGuideModalVisible;
            },
            set(value) {
                this.$store.commit(
                    "interface/setInfluencerGuideModalVisible",
                    value
                );
            },
        },
    },
    components: {
        CreatorInviteGuides,
    },
};
</script>